const STORAGE_KEY = 'boss-theme';

function applyTheme(theme) {
  document.documentElement.setAttribute('data-boss-theme', theme);
  localStorage.setItem(STORAGE_KEY, theme);

  const header = document.querySelector('#header-component');
  if (header) {
    header.setAttribute(
      'data-theme-color',
      theme === 'dark' ? 'rgb(26, 20, 16)' : 'rgb(255, 255, 255)'
    );
  }

  document.querySelectorAll('[data-boss-theme-toggle]').forEach((button) => {
    const isDark = theme === 'dark';
    const lightLabel = button.dataset.bossThemeTitleLight || 'Switch to light theme';
    const darkLabel = button.dataset.bossThemeTitleDark || 'Switch to dark theme';
    const nextLabel = isDark ? lightLabel : darkLabel;

    button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
    button.setAttribute('aria-label', nextLabel);
    button.setAttribute('title', nextLabel);
  });
}

function initThemeSwitcher() {
  document.querySelectorAll('[data-boss-theme-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const current = document.documentElement.getAttribute('data-boss-theme') || 'dark';
      applyTheme(current === 'dark' ? 'light' : 'dark');
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  applyTheme(document.documentElement.getAttribute('data-boss-theme') || 'dark');
  initThemeSwitcher();
});
